// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U7):
// the loader warms the member through the same queryOptions the screen reads.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { MemberDetail } from '../../../../../features/members/MemberDetail'
import { memberQuery } from '../../../../../features/members/queries'
import { Part } from '../../../../../shared/shell/StatePart'

export const Route = createFileRoute('/o/$orgSlug/people/$membershipId/')({
  staticData: { screenId: 'MemberDetailScreen', access: 'member.read' },
  loader: async ({ context: { queryClient, membership }, params }) => {
    await queryClient.ensureQueryData(memberQuery(membership.orgId, params.membershipId))
    return { orgId: membership.orgId }
  },
  component: MemberDetailScreen,
})

function MemberDetailScreen() {
  const { orgId } = Route.useLoaderData()
  const params = Route.useParams()
  return (
    <main data-testid={ids.memberDetail.root}>
      <Part testId={ids.memberDetail.skeleton}>
        <MemberDetail orgId={orgId} orgSlug={params.orgSlug} membershipId={params.membershipId} />
      </Part>
    </main>
  )
}
